import { render, staticRenderFns } from "./AusAbout.vue?vue&type=template&id=2d234810"
import script from "./AusAbout.vue?vue&type=script&lang=js"
export * from "./AusAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports